import type { FetchError } from '@atlassian/jira-fetch';

export type SearchedObject = {
	id: string;
};

export type OptionsType<T> = {
	value: string;
	label: string;
	rawData: T;
};

export type SearchReturnType<T> = {
	results: T[];
	fetchNextPage: (() => Promise<SearchReturnType<T>>) | undefined;
	total?: number;
};

type InputActionTypes = 'set-value' | 'input-change' | 'input-blur' | 'menu-close';

export type InputActionMeta = {
	action: InputActionTypes;
};

export const Actions = Object.freeze({
	APPEND: 'APPEND',
	REPLACE: 'REPLACE',
});

export type Action = (typeof Actions)[keyof typeof Actions];

export type PaginatedObjectAutocompleteReturnType<T> = {
	error: undefined | FetchError;
	selectProps: {
		isLoading: boolean;
		options: OptionsType<T>[];
		onInputChange: (arg1: string, arg2: InputActionMeta) => void;
		onMenuScrollToBottom: () => Promise<void>;
		onMenuOpen: () => Promise<void>;
		onMenuClose: () => void;
	};
	totalNumberOfResults: undefined | number;
};
